import React, { useState, useEffect, useRef } from 'react';
import { useStyle } from './PrequalStyle.js';
import EirFixedBundleCard from './EirFixedBundleCard';
import { Typography, Button } from '@material-ui/core';

import { settings } from './BundleCardContainerCarouselSettings';
import { useLocalStorage } from './EirPrequalPersistance.js';
import { getContext, scrollToTop } from './EirPrequalUtil.js';
import { recommendedBundlesPrefixUrl } from './Constants';

import PubSub from 'pubsub-js';
import axios from 'axios';
import Slider from 'react-slick';
import Constants from '../../Constants';
import Dom from '../../utils/Dom';
import {
    checkAvailabilityText,
} from './Constants.js';
import { checkPrequalForm } from './EirPrequalUtil.js';

export default function EirFixedBundleCardContainer(props) {
    const [bundleData, setBundleData] = useState([]);
    const [title, setTitle] = useState(props.titleBeforePrequal);
    const [subTitle, setSubTitle] = useState();
    const [buttonText, setButtonText] = useState(props.ctaText);
    const [useBroadbandCardColor, setUseBroadbandCardColor] = useState(false);
    const [showCheckAvailability, setShowCheckAvailability] = useState(true);
    let url = useRef('');
    const [currentSlide, setCurrentSlide] = useState(0);
    const [slide_flag, setSlide_Flag] = useState(true);

    const { getLocalStorage, setLocalStorage } = useLocalStorage();
    const classes = useStyle({
        themeColor: props.themeColor,
        themeColorOnHover: props.themeColorOnHover,
        themeColorForBroadbandCards: props.themeColorForBroadbandCards,
        themeColorForBroadbandCardsHover: props.themeColorForBroadbandCardsHover,
        useBroadbandCardColor: useBroadbandCardColor,
    });
    const context = getContext();
    let bundleOfferLists = props.fixedBundleOfferLists[0];

    const setDataLayer = (title, url) => {
        dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: url,
            virtualPageTitle: title,
        });
    };

    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);

    useEffect(() => {
        // const typeOfContext=getLocalStorage('ls-eir_clicked_context');
        // if (context === 'broadband' && typeOfContext==='broadband') {
        //     window.history.pushState({}, '', window.location.origin + '/broadband/results');

        // }
        // if (context === 'tv' && typeOfContext==='tv') {
        //     window.history.pushState({}, '', window.location.origin + '/tv/results');

        // }
        //for buidling url before prequal
        let buildPrequalURL = () => {
            let bundleOfferIds = bundleOfferLists.fixedBundleOffers
                .map(bundleOffer => bundleOffer.id)
                .join(',');
            return `${props.dataUrl}?bundleOfferIds=${bundleOfferIds}`;
        };

        //for buidling url after prequal
        let buildPostPrequalURL = () => {
            let prequalId = getLocalStorage('eir_prequal_data').id;
            if (context === 'generic') {
                return `${recommendedBundlesPrefixUrl}${prequalId}`;
            }
            else {
                return `${recommendedBundlesPrefixUrl}${prequalId}?context=${context}`;
            }
        };
        //function for setting customer type
        const setCustomerType = data => {
            if (data.customerType.toUpperCase() === 'NEW')
                setLocalStorage('global_customer_type', 'new');
            else setLocalStorage('global_customer_type', 'existing');
        };
        //function to fetch bundles
        async function getBundles(URL) {
            await axios({
                method: 'get',
                url: props.customerType ? `${URL}&customerType=${props.customerType}` : `${URL}`,
            })
                .then(res => {
                    if (res.data instanceof Array) setBundleData(res.data);
                    else {
                        setLocalStorage('eir_prequal_result', res.data);
                        setLocalStorage('eir_prequal_bundles', res.data);
                        setLocalStorage('ls-eir_clicked_context', context);
                        setBundleData(res.data.recommendedBundles);
                        setCustomerType(res.data);
                    }
                })
                .catch(() => { });
        }
        if (getLocalStorage('eir_prequal_data') && getLocalStorage('prequaled_from') === checkPrequalForm() ) {
            //this will be used when prequal is done, and page is refreshed
            setTitle(props.titleAfterPrequal);
            setSubTitle(props.subTitleAfterPrequal);
            setButtonText(props.ctaText);
            setShowCheckAvailability(false);
            url.current = buildPostPrequalURL();
            getBundles(url.current);
        } else {
            //for first render
            setTitle(props.titleBeforePrequal);
            setSubTitle();
            setShowCheckAvailability(true);
            url.current = buildPrequalURL();
            getBundles(url.current);
        }
        //whenever prequal happens, url will change to recommended bundles
        PubSub.subscribe('PREQUAL_SUCCESS', () => {
            setTitle(props.titleAfterPrequal);
            setSubTitle(props.subTitleAfterPrequal);
            setShowCheckAvailability(false);
            url.current = buildPostPrequalURL();
            getBundles(url.current);

            // if (context === 'broadband') {
            //     window.history.pushState({}, '', window.location.origin + '/broadband/results');
            //     setDataLayer(`Post-Prequal| eir.ie`, '/broadband/results');
            // }
            // if (context === 'tv') {
            //     window.history.pushState({}, '', window.location.origin + '/tv/results');
            //     setDataLayer(`Post-Prequal| eir.ie`, '/tv/results');
            // }
        });

        //whenever prequal page changes, url will change to suggested bundles
        PubSub.subscribe('PREQUAL_FAILURE', () => {
            setTitle(props.titleBeforePrequal);
            setSubTitle();
            setShowCheckAvailability(true);
            url.current = buildPrequalURL();
            getBundles(url.current);
            // window.history.pushState(
            //     {},
            //     '',
            //     window.location.origin + `${getLocalStorage('context')}/results`
            // );
        });
    }, []);

    //To check tv is eligible or not
    useEffect(() => {
        setUseBroadbandCardColor(false);
        if (context === 'tv' && getLocalStorage('eir_prequal_data') && getLocalStorage('prequaled_from') === checkPrequalForm()) {
            const prequalData = getLocalStorage('eir_prequal_data');
            if (prequalData.inbi) {
                setUseBroadbandCardColor(true);
            } else {
                setUseBroadbandCardColor(!prequalData.itv);
            }
        }

    }, [getLocalStorage('eir_prequal_data')]);

    useEffect(() => {
        setSlide_Flag(true);
    }, [bundleData]);

    return (
        <div id={'bundle_card_data'} className={classes.BundleCardContainerWrapper}>
            <Typography className={classes.BundleContainerTitle}>{title}</Typography>
            <div className={classes.SubTitleAfterPrequal}>{subTitle}</div>
            <div
                className={
                    classes.BundleCardContainer +
                    ' ' +
                    (bundleData.length == 1 ? classes.SingleCardContainer : '')
                }>
                <Slider {...settings} className={classes.BundleCardSlider}
                    ref={(e) => {
                        if (slide_flag && e != null && e.props != undefined && e.props.children != undefined && e.props.children.length != 0) {
                            e.slickGoTo(Math.floor((e.props.children.length - 1) / 2));
                            setCurrentSlide(Math.floor((e.props.children.length - 1) / 2));
                            setSlide_Flag(false);
                        }
                    }}
                    afterChange={(e) => {
                        setCurrentSlide(e);
                    }}
                >
                    {bundleData.map((ele, index) => {
                        return (
                            <EirFixedBundleCard
                                key={ele.id}
                                index={index}
                                currentSlide={currentSlide}
                                BundleData={ele}
                                bundleButton={props.ctaText}
                                themeColor={props.themeColor}
                                themeColorOnHover={props.themeColorOnHover}
                                themeColorForBroadbandCards={props.themeColorForBroadbandCards}
                                themeColorForBroadbandCardsHover={props.themeColorForBroadbandCardsHover}
                                changeImageOnHover={props.changeImageOnHover}
                                totalCards={bundleData.length}
                                useBroadbandCardColor={useBroadbandCardColor}
                            />
                        );
                    })}
                </Slider>
            </div>
            {showCheckAvailability &&
                <div className={classes.bundleCardContainerCheckAvailabilityButtonContainer}>
                    <Button
                        id='check_via_eircode'
                        disableRipple={true}
                        className={classes.bundleCardContainerCheckAvailabilityButton}
                        onClick={() => scrollToTop()}>
                        {checkAvailabilityText}
                    </Button>
                </div>
            }

        </div>
    );
}
